<template lang="pug">
.page 
    a-tabs(default-active-key="on" v-if="perm.marketing_channel_id")
        a-tab-pane(key="on" tab="Option Page")
            TabContent(:bookName="bookName"
                :columns="columns" 
                :autoRefresh="5"
                :rowSpanColumns="['stock_name', 'stock_code', 'curr_stock_contract', 'curr_stock_price', 'cum_stock_pnl', 'delta_diff', 'delta_diff_pct', 'action', 'delta_hedging', 'buy_sell', 'hedging_gain_loss', 'total_pnl', 'hedging_threshold', 'max_delta_deviation', 'trader_confidence', 'cumulative_stock_pnl', 'total_daily_pnl', 'stock_daily_pnl', 'price_diff_pct']"
                status='on'
                :viewOnly="true")

        a-tab-pane(key="done" tab="Done Trades")
            TabContent(:bookName="bookName"
                :columns="columns" 
                :autoRefresh="0"
                :rowSpanColumns="['stock_name', 'stock_code']"
                status='off'
                :viewOnly="true")
</template>

<script>
import _ from 'lodash';
import TabContent from './TabContent.vue';
import { editAbleColumns, SalesInputColumns, InitialDataColumns, CurrentPositionColumns, HedgingColumns, BookingColumns } from './columns';

export default {
    data() {
        let allCols = _.concat(editAbleColumns, SalesInputColumns, InitialDataColumns, CurrentPositionColumns, HedgingColumns, BookingColumns);

        return {
            allCols,
            columns: [],
            perm: {},
        }
    },
    mounted() {
        // this.getSelectCols();
        this.getPerm().then(() => {
            this.getSelectCols();
        });
    },
    methods: {
        async getPerm() {
            let res = await this.$api.request('GET', 'hkoption/perms', {});
            this.perm = res.data;
        },
        getSelectCols() {
            this.$api.request('GET', 'hkoption/selectCols', {page: 'market'})
                .then(res => {
                    let selectKeys = _.uniq(_.concat(res.data.fixedCols, res.data.cols));

                    let fixedSelectKeys = res.data.fixedCols;

                    this.disSelectedCols = this.allCols.filter(i => !selectKeys.includes(i.dataIndex));
                    
                    let colValue = _.chain(this.allCols)
                        .map(i => [i.dataIndex, i])
                        .fromPairs()
                        .value();
                    
                    this.selectedCols = selectKeys.map(i => colValue[i]).filter(i => !!i);
                    this.fixedSelectCols = fixedSelectKeys.map(i => colValue[i]).filter(i => !!i);

                    this.columns = _.concat(this.selectedCols, [{
                        title: '操作',
                        width: 70,
                        fixed: 'right',
                        scopedSlots: {
                            customRender: 'operate'
                        }
                    }]).map(i => {
                        if (fixedSelectKeys.includes(i.dataIndex)) {
                            i.fixed = 'left';
                            i.width = i.width || 90;
                        }

                        if (i.percentDisplay) {
                            i.scopedSlots = {
                                customRender: 'percentDisplay'
                            }
                        }
                        else if (i.type == 'Number') {
                            i.scopedSlots = {
                                customRender: 'numberDisplay'
                            }
                        }
                        else if (i.type == 'Boolean') {
                            i.scopedSlots = {
                                customRender: 'boolDisplay'
                            }
                        }
                        return i;
                    });
                })
        },
    },
    computed: {
        bookName() {
            // return 'marking_channel_亚丁'
            return `marking_channel_${this.perm.marketing_channel_id}`
        }
    },
    components: {
        TabContent
    }
}
</script>